export class DeleteModalProperties {

    public data: any;
    public apiName: string;

    constructor() { }
}
